import { render, staticRenderFns } from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=template&id=35d7d2f2&"
import script from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=script&lang=js&"
export * from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports